<div class="modal-header">
  <h4 class="modal-title" id="exampleModalLabel">
    <b>{{ "deleteFranchisePopup.title" | translate }} - </b> <span style="font-size: 16px;">{{ companyName }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()" ></button>
</div>
<div class="modal-body">
  <span
    class="d-flex text-wrap"
    [ngClass]="'alert'"
    style="background-color: #FFE899; color: #E56B00; border-radius: 4.45px;"
  >
    <i class="icofont icofont-info-circle"></i>
    <div class="lh-base" style="font-size: 12px;">
      {{ "deleteFranchisePopup.warning" | translate }}
    </div>
  </span>
  <span style="font-size: 16px;">{{ "deleteFranchisePopup.lpList" | translate }}</span>
  <div style="margin: 15px 0px">
    <ng-select
      [items]="locationsPerFranchise"
      [multiple]="true"
      groupBy="label"
      [selectableGroup]="true"
      [selectableGroupAsModel]="false"
      [closeOnSelect]="false"
      bindValue="companyName"
      bindLabel="companyName"
      [(ngModel)]="selectedLocations"
      [placeholder]="'deleteFranchisePopup.locationsPlaceholder' | translate"
    >
      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
        <div class="form-check checkbox checkbox-primary mb-0 ml-10">
          <input
            class="form-check-input m-r-10"
            type="checkbox"
            id="item-{{ index }}"
            [ngModel]="item$.selected"
          />
          <label class="form-check-label label">{{ item.label | translate }}</label>
        </div>
        <!-- <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.label | translate }} -->
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <div class="form-check checkbox checkbox-primary mb-0 ml-10">
          <input
            class="form-check-input m-r-10"
            type="checkbox"
            id="item-{{ index }}" 
            [ngModel]="item$.selected"
          />
          <label class="form-check-label label">{{ item.companyName }}</label>
        </div>
        <!-- <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.companyName }} -->
      </ng-template>
    </ng-select>
  </div>
</div>
<div class="modal-footer">
  <div style="display: flex; justify-content: space-between; width: 100%;">
    <button class="btn btn-outline-primary" (click)="closeModal()">
      {{ "buttons.cancel" | translate }}
    </button>
    <div style="display: flex; gap: 16px;">
      <button class="btn btn-primary" (click)="onClickDeleteFranchiseOnly()">
        {{ "deleteFranchisePopup.deleteFranchiseOnly" | translate }}
      </button>
      <button class="btn btn-primary" (click)="onClickDeleteAlongWithLocations()" [disabled]="!selectedLocations.length && locationsPerFranchise.length">
        {{ "buttons.confirm" | translate }}
      </button>
    </div>
  </div>
</div>
